import styled, { css } from 'styled-components';

import Modal from 'components/modal';

const bgColor = css`
  background-color: ${Styles.color.grey.five};
`;

export const StyledModal = styled(Modal)`
  ${Styles.desktop`
    &[data-reach-dialog-content] {
      width: 90%;
      min-height: 95%;
      max-width: 650px;
    }
  `};
`;

export const Container = styled.div`
  width: 90%;
  max-width: 390px;
  margin: 0 auto;
`;

export const ModalHead = styled.div`
  position: fixed;
  width: 100%;
  height: 5.5rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  z-index: ${Styles.zIndex.top};
  border-bottom: 1px solid ${Styles.color.grey.four};
  ${bgColor}

  ${Styles.desktop`
    flex-direction: row;
  `}

  h2 {
    margin: 0;
  }
`;

export const ModalInner = styled.div`
  height: 100%;
  width: 100%;
  ${bgColor}

  h2 {
    text-align: center;
    margin: 2rem 0;
    text-transform: ${Styles.textTransform.headlines};
    font-family: ${Styles.fontFamily.base};
  }
`;

export const Block = styled.div`
  padding: 0 0 1rem 0;

  :nth-of-type(n + 2) {
    border-top: 1px solid ${Styles.color.grey.four};
    padding: 1rem 0;
  }
  :last-of-type {
    margin-bottom: 1.5rem;
  }
`;

export const OrderDetailsScrollContainer = styled.div`
  position: relative;
  height: calc(100% - 164px);
  padding-top: 7.75rem;
  padding-bottom: 2.25rem;
  overflow-y: auto;
`;

export const Footer = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0;
  border-top: 1px solid ${Styles.color.grey.four};
  padding: 1rem 0;
  ${bgColor}

  p {
    color: ${Styles.color.grey.one};
  }
`;

export const LoadingContainer = styled.div`
  left: 0;
  top: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

/*
 * this duplicates the amount of spacing around an ActionLink
 * so that the loading indicator can transition to an ActionLink
 * without elements around it shifting on the page
 */
export const NeedHelpButtonLoadingIndicatorWrapper = styled.div`
  padding: 0.7rem;
  border: '1px solid transparent';
`;
